import React, { useEffect, useRef } from 'react';
import './thirdsec.css'
import leftTop from './../assets/cards.png'
import leftBottom from './../assets/left-down.png'
import rightSinger from './../assets/ummkulthum3.png'
import PaperCard from '../components/papercard';

const ThirdSec = () => {

const sectionRef = useRef();

useEffect(() => {
  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      sectionRef.current.classList.add("show");
    }
  }, { threshold: 0.25 });

  observer.observe(sectionRef.current);
}, []);

return (
<>
<section ref={sectionRef} className="third-section">

<img src={leftTop} className="top-left"/>
<img src={leftBottom} className="bottom-left"/>
<img src={rightSinger} className="right-singer"/>

<div className="cards-container">

<div className="row">
<PaperCard title="Powerful Voice"/>
<PaperCard title="Influential Artist"/>
</div>

<div className="row">
<PaperCard title="Cultural Icon"/>
<PaperCard title="Timeless Legacy"/>
</div>

<div className="row center">
<PaperCard title="Elegant"/>
</div>

</div>

</section>
</>
);
}

export default ThirdSec;